/** @jsx isolateComponent */

import { Button } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

type Props = {
  onClick: () => void;
};

export const CancelButton = ({ onClick }: Props) => (
  <Button color="secondary" onClick={onClick}>
    Back
  </Button>
);
